import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotThumbsDown = ({
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <path
            fill={spotColor}
            d="M24.16 4.097A2.54 2.54 0 0 0 22.163.674 29.02 29.02 0 0 0 19.02.462c-1.76-.65-4.224-.446-5.97-.378a15.114 15.114 0 0 0-7.723 2.17C1.382 4.822-1.164 10.361.537 14.948c1.783 4.821 7.73 6.046 12.226 5.101a15.87 15.87 0 0 0 11.374-9.915c.83-2.327.816-4.458.022-6.038Z"
            opacity={0.8}
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M28.332 3.333h4.45a3.85 3.85 0 0 1 3.884 3.333v11.667a3.85 3.85 0 0 1-3.884 3.334h-4.45M16.666 25v6.666a5 5 0 0 0 5 5l6.666-15V3.334h-18.8A3.333 3.333 0 0 0 6.2 6.166l-2.3 15A3.333 3.333 0 0 0 7.232 25h9.434Z"
        />
    </SVG>
);
SpotThumbsDown.displayName = "SpotThumbsDown";
